import { Alert, AlertDescription, AlertTitle, AlertIcon } from 'components/UI';

const PendingApproval = () => (
  <Alert flexDirection="column" alignItems="center" status="success" justifyContent="center" bgColor="transparent">
    <AlertIcon mb={2} boxSize="40px" mr={0} color="primaryThemeColour.400" />
    <AlertTitle mb={2} color="black">
      Thank you for registering.
    </AlertTitle>
    <AlertDescription textAlign="center">
      Your account has been submitted for approval. <br /> You&apos;ll receive a notification when the status has been
      updated.
    </AlertDescription>
  </Alert>
);

export default PendingApproval;
